import React from 'react';
import './Contact.css';

const Contact = () => {
    return <div className="contactus">Contact Us</div>;
};
export default Contact;
